import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'edit-icon';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconEdit = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;
    const classNames = cx(addClasses, 'inline');

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Edit Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M20.504 10.424l-9.56 10.107a1.5 1.5 0 01-1.09.469H5.5A1.5 1.5 0 014 19.5v-4.393c0-.39.152-.763.423-1.043l9.659-9.97a1.5 1.5 0 012.138-.016l4.255 4.254a1.5 1.5 0 01.029 2.092z"
                    fill={fill}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
